import * as PropTypes from "prop-types";
import {connect} from 'react-redux'
import {Component} from "react";
import * as React from "react";
import {Field} from "redux-form";
import {Col, Label, Row} from "reactstrap";

/**
 * Klasický select vracející jako hodnotu objekt.
 * Umožňuje volitelně zobrazit prázdnou položku.
 *
 * Pozor, funkční zatím jen pro objekty s atributem "id"!
 */
class ObjectSelect extends Component {

    static propTypes = {
        items: PropTypes.array, // pole objektů
        getItemValue:  PropTypes.func, // funkce pro načtení hodnoty pro zobrazení uživateli - název položky, předpis: (item) => {}
        itemValueAttrName: PropTypes.string, // název atributu v objektu, který je možné použít jako název pro zobrazení uživateli - je možné definovat jen atribut místo celé metody getItemValue, implicitně má hodnotu "name"
        showEmpty: PropTypes.bool, // zda v selectu zobrazit i prázdnou položku (např. pro nepovinné údaje), implicitně false
        label: PropTypes.string, // label vedle fieldu, pokud není uveden nebude zobrazen
    };

    static defaultProps = {
        itemValueAttrName: "name",
        items: [],
        showEmpty: false,
        required: false,
    };

    handleChange = (field, e) => {
        const {items} = this.props;
        if (e && e.target && e.target.value) {
            const item = items.find(i => i.id === parseInt(e.target.value));
            if (item) {
                field.input.onChange(item);
            }
        } else {
            field.input.onChange(null);
        }
    };

    renderField = (field) => {
        const {items, label, itemValueAttrName, getItemValue, showEmpty, required} = this.props;
        const select = <select className="input-row form-control" onChange={this.handleChange.bind(this, field)} value={field.input.value ? field.input.value.id : ""} disabled={field.disabled} required={required}>
            {showEmpty && <option key={0}/>}
            {items && Array.isArray(items) && items.map(item =>
                <option key={item.id} value={item.id}>{getItemValue && typeof getItemValue === 'function' ? getItemValue(item) : item[itemValueAttrName]}</option>
            )}
        </select>;
        if (label) {
            return <Row className="form-group">
                <Label xs={12} sm={4} className="col-form-label">{label}</Label>
                <Col xs={12} sm={8}>{select}</Col>
            </Row>
        } else {
            return select;
        }
    };

    render() {
        const {label, items, itemValueAttrName, getItemValue, showEmpty, required, ...other} = this.props;
        return <Field {...other} component={this.renderField}/>
    }
}

export default connect()(ObjectSelect);
